import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, Link, useLocation } from "react-router-dom";
import { Show, SignIn, SignUp } from "@clerk/react";
import { Toaster } from "sonner";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import { MemberProvider } from "@/components/MemberProvider";
import { Header } from "@/components/Header";
import Home from "@/pages/Home";
import Meeting from "@/pages/Meeting";
import Favourites from "@/pages/Favourites";
import Admin from "@/pages/Admin";
import Tips from "@/pages/Tips";
import Terms from "@/pages/Terms";
import Record from "@/pages/Record";
import FormBot from "@/pages/FormBot";
import { AgeGate } from "@/components/AgeGate";
import { TermsGate } from "@/components/TermsGate";

const Private = ({ children }) => (
  <>
    <Show when="signed-in">{children}</Show>
    <Show when="signed-out"><Navigate to="/sign-in" replace /></Show>
  </>
);

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

const AuthWrap = ({ children }) => <div className="flex items-center justify-center py-16 px-4">{children}</div>;

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <ClerkAuthProvider>
        <MemberProvider>
          <div className="min-h-screen">
            <Header />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/meeting/:id" element={<Meeting />} />
              <Route path="/tips" element={<Tips />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/record" element={<Record />} />
              <Route path="*" element={<div className="max-w-xl mx-auto px-4 py-24 text-center" data-testid="not-found-page"><h1 className="text-4xl font-black uppercase mb-3">Page not found</h1><p className="text-slate-400 mb-6">That page doesn't exist.</p><Link to="/" className="text-blue-400 underline">Back to meetings</Link></div>} />
              <Route path="/favourites" element={<Private><Favourites /></Private>} />
              <Route path="/admin" element={<Private><Admin /></Private>} />
              <Route path="/bot" element={<Private><FormBot /></Private>} />
              <Route path="/sign-in/*" element={<AuthWrap><SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" withSignUp /></AuthWrap>} />
              <Route path="/sign-up/*" element={<AuthWrap><SignUp routing="path" path="/sign-up" signInUrl="/sign-in" /></AuthWrap>} />
            </Routes>
            <footer className="border-t border-white/5 py-8 text-center text-xs text-slate-500">
              <p>The Weekend Edge · Form analysis for Australian racing · 18+ only · Gamble responsibly — call 1800 858 858</p>
              <Link to="/terms" data-testid="footer-terms-link" className="inline-block mt-2 text-slate-400 hover:text-blue-400 underline underline-offset-2">Terms & Conditions</Link>
            </footer>
          </div>
          <AgeGate />
          <TermsGate />
          <Toaster theme="dark" position="top-right" offset={{ top: 80 }} mobileOffset={{ top: 72 }} richColors />
        </MemberProvider>
      </ClerkAuthProvider>
    </BrowserRouter>
  );
}

export default App;
